import { render, staticRenderFns } from "./ModalSuccess.vue?vue&type=template&id=ba21c14e&scoped=true"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"
import style0 from "./ModalSuccess.vue?vue&type=style&index=0&id=ba21c14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba21c14e",
  null
  
)

export default component.exports